import { Table, Text } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';

function TransferHeaderCells() {
  const t = useTranslationCatalog();

  return (
    <>
      <Table.Cell width="34%">
        <Text fontWeight="bold">
          {t('transfers.detail.table.headers.products')}
        </Text>
      </Table.Cell>
      <Table.Cell width="38%">
        <Text fontWeight="bold">
          {t('transfers.detail.table.headers.variations')}
        </Text>
      </Table.Cell>
      <Table.Cell width="10%">
        <Text fontWeight="bold">
          {t('transfers.detail.table.headers.requested')}
        </Text>
      </Table.Cell>
      <Table.Cell width="10%">
        <Text fontWeight="bold">
          {t('transfers.detail.table.headers.done')}
        </Text>
      </Table.Cell>
      <Table.Cell width="8%">
        <Text fontWeight="bold">
          {t('transfers.detail.table.headers.status')}
        </Text>
      </Table.Cell>
    </>
  );
}

export default TransferHeaderCells;
